/*!
 *    Copyright 2015-2016 Thomas Rosenau
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
const sortKeys = (o) => {
  if (Array.isArray(o)) {
    return o.map(sortKeys);
  } else if (o instanceof Object) {
    let numeric = [];
    let nonNumeric = [];
    Object.keys(o).forEach((key) => {
      if (/^(0|[1-9][0-9]*)$/.test(key)) {
        numeric.push(+key);
      } else {
        nonNumeric.push(key);
      }
    });
    return numeric.sort(function(a, b) {
      return a - b;
    }).concat(nonNumeric.sort()).reduce((result, key) => {
      result[key] = sortKeys(o[key]);
      return result;
    }, {});
  }
  return o;
};
const jsonStringify = JSON.stringify.bind(JSON);
const sortify = (value, replacer, space) => {
  let nativeJson = jsonStringify(value, replacer, 0);
  if (!nativeJson || nativeJson[0] !== "{" && nativeJson[0] !== "[") {
    return nativeJson;
  }
  let cleanObj = JSON.parse(nativeJson);
  return jsonStringify(sortKeys(cleanObj), null, space);
};
export default sortify;
